module.exports = __webpack_public_path__ + "highlandsport-logo.svg?46758c0068dbc7a37573315e963e4840";